import React from 'react';
import { Types } from 'utils/constants';
import RecordMenuContext from './record-menu.context';


const RecordMenuContextProvider = ({ children }) => {
  const moveToEventAction = (exerciseId, eventId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'MOVE_TO_EVENT',
        params: { exerciseId, eventId }
      }
    }));
  }

  const duplicateEvent = (eventId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DUPLICATE_EVENT',
        params: { recordId: eventId, recordType: Types.Record.EVENT }
      }
    }));
  }

  const duplicateExercise = (exerciseId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DUPLICATE_EXERCISE',
        params: { recordId: exerciseId, recordType: Types.Record.EXERCISE }
      }
    }));
  }

  const deleteExercise = (exerciseId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DELETE_EXERCISE',
        params: { recordId: exerciseId, recordType: Types.Record.EXERCISE }
      }
    }))
  }

  const deleteEvent = (eventId, sourceExerciseId = null) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DELETE_EVENT',
        params: { recordId: eventId, recordType: Types.Record.EVENT, sourceExerciseId }
      }
    }))
  }

  const deleteDeployment = (deploymentId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DELETE_DEPLOYMENT',
        params: { recordId: deploymentId, recordType: Types.Record.DEPLOYMENT }
      }
    }))
  }

  const deleteCompletedAnswers = (exerciseId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DELETE_COMPLETED_ANSWERS',
        params: { exerciseId }
      }
    }))
  }

  const deleteClass = (classId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DELETE_CLASS',
        params: { recordId: classId, recordType: Types.Record.CLASS }
      }
    }))
  }

  const deleteVetVisit = (vetVisitId) => {
    setRecordMenuState(prev => ({
      ...prev,
      action: {
        type: 'DELETE_VET_VISIT',
        params: { recordId: vetVisitId, recordType: Types.Record.VET_VISIT }
      }
    }))
  }

  const closeAction = () => {
    setRecordMenuState(prev => ({
      ...prev,
      isLoading: false,
      action: {
        type: '',
        params: null
      }
    }));
  }

  const setIsLoading = (isLoading) => {
    setRecordMenuState(prev => ({
      ...prev,
      isLoading
    }));
  }

  const [recordMenuState, setRecordMenuState] = React.useState({
    isLoading: false,
    action: {
      type: '',
      params: null
    },
    moveToEventAction,
    duplicateEvent,
    duplicateExercise,
    deleteExercise,
    deleteEvent,
    deleteDeployment,
    deleteCompletedAnswers,
    deleteClass,
    deleteVetVisit,
    closeAction,
    setIsLoading
  });

  return (
    <RecordMenuContext.Provider value={recordMenuState} >
      {children}
    </RecordMenuContext.Provider>
  );

}

export default RecordMenuContextProvider;